import cn from 'classnames';
import s from './GuestPhoto.module.scss';

export default function GuestPhoto({ src, alt, withBorder }) {
  return (
    <div
      className={cn(s.wrapper, {
        [s.withBorder]: withBorder,
      })}
    >
      {src && <img src={src} alt={alt} />}
    </div>
  );
}
